/**
 * @file  pagination/rc-pagination/Pager
 * @author chenyaqiu
 */
import React from 'react';
import classNames from 'classnames';
;
const Pager = ({ onClick, page, rootPrefixCls, active, className, onKeyPress, showTitle, disabled, itemRender }) => {
    const prefixCls = `${rootPrefixCls}-item`;
    const cls = classNames(prefixCls, `${prefixCls}-${page}`, {
        [`${prefixCls}-active`]: active,
        [className]: !!className,
        [`${prefixCls}-disabled`]: !page
    });
    const handleClick = React.useCallback(() => {
        onClick(page);
    }, [onClick, page]);
    const handleKeyPress = React.useCallback(e => {
        onKeyPress(e, onClick, page);
    }, [onKeyPress, onClick, page]);
    return (<li title={showTitle ? page.toString() : ''} className={cls} onClick={handleClick} onKeyPress={handleKeyPress} tabIndex={0} aria-disabled={disabled}>
            {itemRender(page, 'page', <a rel="nofollow" aria-disabled={disabled}>{page}</a>)}
        </li>);
};
export default Pager;
